import phoneModelValidator from 'forms/shared/validators/models/phone/phone';
import locationCityStateModelValidator from 'forms/shared/validators/models/location/models/cityState';
import { ValidateJSModel } from 'forms/shared/types';
import { isPVQForm } from 'helpers/form';
import { hasYesOrNo } from 'models/validate';
import pvqLocationModelValidator from 'forms/shared/validators/models/location/pvqLocation';
import { isSafeUnitedStates } from 'helpers/locations';
import { FinancialCreditItemModel } from '../types';

const financialCreditItemValidator: ValidateJSModel<FinancialCreditItemModel> = {
  Explanation: (value, attributes, attributeName, options) => ((isPVQForm(options?.formType)) ? {} : { hasValue: true }),

  Name: { hasValue: true },

  Telephone: {
    presence: true,
    model: { validator: phoneModelValidator, requireNumber: true },
  },

  Location: (value, attributes, attributeName, options) => ({
    presence: true,
    location: isPVQForm(options?.formType) ? {
      validator: pvqLocationModelValidator,
      requireStreet: true,
      requireIsMilitaryDiplomaticAddress: true,
      requireMilitaryDiplomaticInstallationName: true,
      requireApoFpoDpoPostcode: !isSafeUnitedStates(value),
    } : {
      validator: locationCityStateModelValidator,
    },
  }),

  Description: (value, attributes, attributeName, options) => (isPVQForm(options?.formType) ? {} : { hasValue: true }),

  InstallationCountry: {},

  HasBeenEffective: (value, attributes, attributeName, options) => (isPVQForm(options?.formType) ? {
    hasValue: { validator: hasYesOrNo },
  } : {}),

  Why: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && (attributes.HasBeenEffective?.value === 'Yes' || attributes.HasBeenEffective?.value === 'No')) {
      return { hasValue: true };
    }

    return {};
  },

  How: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && (attributes.HasBeenEffective?.value === 'Yes' || attributes.HasBeenEffective?.value === 'No')) {
      return { hasValue: true };
    }

    return {};
  },
};

export default financialCreditItemValidator;
